import { render, staticRenderFns } from "./u-sub-head-basic.vue?vue&type=template&id=4eea3237&scoped=true&"
import script from "./u-sub-head-basic.vue?vue&type=script&lang=js&"
export * from "./u-sub-head-basic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eea3237",
  null
  
)

export default component.exports